import { api } from '@/api/client';
import { useSessionStore } from '@/state/sessionStore';
import { isLanguage, type Language } from './translate';
import { useLanguageStore } from './languageStore';

/**
 * While signed in, the language lives with the account as well as in this browser: a browser that has not been used
 * before starts in the account's language, and a change made here is saved to the account.
 */
export function startAccountLanguageSync(): () => void {
  const store = useLanguageStore;
  let saved: Language | null = null;
  const save = (language: Language) => {
    if (saved === language) return;
    saved = language;
    void api.patch('/accounts/me/profile', { language }).catch(() => {
      saved = null; // try again at the next change
    });
  };

  const stored = useSessionStore.getState().member?.language;
  if (isLanguage(stored)) {
    saved = stored;
    if (stored !== store.getState().language) store.getState().setLanguage(stored);
  } else {
    save(store.getState().language); // the account has no language yet: it takes this browser's
  }
  return store.subscribe((state, previous) => {
    if (state.language !== previous.language) save(state.language);
  });
}
